import worksheetexample from "../assets/images/worksheetexample.png";
import strokeorder from "../assets/images/strokeorder.png";
import quiz from "../assets/images/quiz.png";
import typing from "../assets/gif/typing.gif";
import vocabulary from "../assets/images/vocabulary.png";

export default {
    typingwords:
        "free and fun Japanese lessons for English speakers",

    header: {
        strokeOrder: "Online Reading & Writing Practice",
        game: 'Game "Which Kana Is This?"',
        typing: 'Flick or Type！',
        vocabulary: 'Swipe & Learn Words!',
        worksheets: "Download Free Worksheets",
        about: "About",
        contact: "Contact",
        message: "Book A Lesson",
    },

    hero: {
        title: "Learn Japanese with Hanapin",
        text: "Learn, connect, and have fun!",
        button: "Start Now",
    },

    cards: [
        {
            href: "/strokeorder",
            title: "Online Reading & Writing Practice",
            desc: "No preparation needed! Start practicing hiragana and katakana reading and writing right away!",
            image: strokeorder
        },
        {
            href: "/game",
            title: 'The Game "Which Kana Is This?"',
            desc: "Can you tell apart the hiragana and katakana that look very similar?",
            image: quiz
        },
        {
            href: "/vocabulary",
            title: "Swipe & Learn Words!",
            desc: "Swipe through flashcards and grow your Japanese vocabulary!",
            image: vocabulary
        },
        {
            href: "/typing",
            title: "Flick or Type!",
            desc: "Flick or type the word you hear in romaji and level up your listening and typing skills!",
            image: typing
        },
        {
            href: "/writing",
            title: "Free Writing Worksheets",
            desc: "Print them out or import them into Goodnotes to practice writing at home!",
            image: worksheetexample
        },
    ],
    about: {
        hanapin: "Hanapin is a Japanese learning channel hosted by Hanapin, who dreams of making friends with people from all over the world. You can study solo, anytime and anywhere, managing everything from materials to review all by yourself. Start learning now on YouTube (English version) or on bilibili (Chinese version).",
        fujiyama: "We, Fujiyama, Inc., plan, produce, and edit Hanapin's videos. Our goal is to create fun, animated content that makes your learning engaging and practical."
    },
    news: [
        { date: "2026.07.08", title: "Swipe & Learn Words! is now live!", content: "Swipe through vocabulary flashcards with images and audio and grow your Japanese vocabulary!", link: "/vocabulary", linkText: "Try it now" },
        { date: "2026.07.08", title: "Flick or Type! is now live!", content: "Practice typing Japanese words using the Japanese keyboard as you hear them and level up your listening and typing skills!", link: "/typing", linkText: "Try it now" },
        { date: "2026.07.01", title: "You can now practice reading and writing kana online.", content: "No preparation needed! Start practicing hiragana and katakana reading and writing right away!", link: "/strokeorder", linkText: "Start Practicing" },
        { date: "2026.06.30", title: "You can now play the game \"Which Kana is This?\"", content: "Can you tell apart the hiragana and katakana that look very similar?", link: "/game", linkText: "Play now" },
        { date: "2026.03.01", title: "The first hiragana lesson has been uploaded!", content: "Go watch on YouTube now!", link: "https://www.youtube.com/channel/UCXFOpp-skK2-psYqVwYOj1g", linkText: "Watch on YouTube" },
        { date: "2026.02.22", title: "The Hanapin website is now live!", content: "New videos will be uploaded on YouTube soon. Stay tuned!", link: "", linkText: "Learn more" },
    ],
    characters: {
        hanapin: {
            name: "Hanapin",
            sub: "Foodie Japanese girl",
            desc: "Hanapin is a friendly Japanese girl born in Japan, who graduated from a boarding high school in Massachusetts and a university in Shanghai. She has a daily bubble tea ritual and a deep love for Chinese hotpot. Her huge appetite often surprises those around her."
        },
        emimaru: {
            name: "Emimaru",
            sub: "Hanapin's Mom",
            desc: "Emimaru is an energetic and talkative drawing artist who loves a good drink. She is currently learning English and Chinese from her daughter Hanapin for future trips abroad. However, since she forgets everything the moment class ends, her language skills haven't improved at all."
        },
        sakura: {
            name: "Sakura",
            sub: "Study-Abroad Vlogger in Shanghai",
            desc: "Sakura is a laid-back Japanese girl who just started studying abroad in Shanghai. While having a hard time adjusting to her new environment, she started a study-abroad vlog to share her experiences. But, her slow editing pace often keeps followers waiting, and she feels bad about it."
        },
    },
    sections: {
        otherLessons: "Other Lessons",
        studyMaterials: "Fun Learning Resources",
        news: "News",
        characters: "Characters",
        watchYouTube: "Watch on YouTube",
    },
    tags: {
        hiragana: "Hiragana",
        katakana: "Katakana",
        single: "Single Character",
        all: "All Characters",
        "cheat-sheet-test": "Cheat Sheet & Test"
    }
};